// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkoutCardDiv {
  width: 22.1%;
  height: 124px;
  border: 1px solid #ececec;
  border-radius: 20px;
  /* margin-top: 32px; */
  margin-right: 24px;
  flex-direction: column;
  display: inline-flex;
  padding-top: 16px;
  padding-left: 16px;
}

.main-card.MuiPaper-root.MuiCard-root {
  box-shadow: none;
}

.card-content-checkout.MuiCardContent-root {
  padding: 32px 24px !important;
}

.checkoutFunnel-card.MuiPaper-root.MuiCard-root {
  height: 396px;
  /* width: 60%; */
  align-self: stretch;
  background: var(--white, #fff);
  border-radius: 16px;
  border: 1.2px solid var(--border-tertiary, rgba(1, 1, 2, 0.12));
  box-shadow: none;
}

.checkout-analytics-content {
  display: grid;
  grid-template-columns: calc(55% - 28px) 45%;
  column-gap: 24px;
  row-gap: 28px;
  margin-top: 28px;
}

.checkout-analytics-card.MuiPaper-root.MuiCard-root {
  height: 396px;
  width: 40%;
  align-self: stretch;
  background: var(--white, #fff);
  border-radius: 16px;
  border: 1.2px solid var(--border-tertiary, rgba(1, 1, 2, 0.12));
  box-shadow: none;
  margin-left: 36px;
}

.funnel-text.MuiTypography-root {
  font-family: "Poppins";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.5px;
}

.info-icon-style {
  margin-right: 8px;
  padding-top: 4px;
}

.split-info-card.MuiPaper-root.MuiCard-root {
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: var(--conditional-pop-over, #fff);
  margin-top: 16px;
  box-shadow: none;
}

.split-info-cardContent.MuiCardContent-root {
  display: flex;
  flex-direction: row;
  padding: 10px 16px !important;
}

.payment-trends-lineChart {
  border-radius: 20px;
  border: 1.4px solid #ececec;
  background: var(--white, #fff);
  box-shadow: none;
  height: 500px;
}

.recharts-legend-wrapper {
  position: absolute !important;
  width: auto !important;
  height: auto !important;
  top: 90px !important;
  right: 0 !important;
  left: 315px !important;
}

.info-icon {
  width: 10px;
  height: 10px;
  margin: auto 0;
  margin-right: 4px;
}

.checkout-analytics-root {
  width: 100%;
  background: #fff;
}

`, "",{"version":3,"sources":["webpack://./src/components/pages/analytics/checkout/checkOut.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,+DAA+D;EAC/D,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,+DAA+D;EAC/D,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,6CAA6C;EAC7C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".checkoutCardDiv {\n  width: 22.1%;\n  height: 124px;\n  border: 1px solid #ececec;\n  border-radius: 20px;\n  /* margin-top: 32px; */\n  margin-right: 24px;\n  flex-direction: column;\n  display: inline-flex;\n  padding-top: 16px;\n  padding-left: 16px;\n}\n\n.main-card.MuiPaper-root.MuiCard-root {\n  box-shadow: none;\n}\n\n.card-content-checkout.MuiCardContent-root {\n  padding: 32px 24px !important;\n}\n\n.checkoutFunnel-card.MuiPaper-root.MuiCard-root {\n  height: 396px;\n  /* width: 60%; */\n  align-self: stretch;\n  background: var(--white, #fff);\n  border-radius: 16px;\n  border: 1.2px solid var(--border-tertiary, rgba(1, 1, 2, 0.12));\n  box-shadow: none;\n}\n\n.checkout-analytics-content {\n  display: grid;\n  grid-template-columns: calc(55% - 28px) 45%;\n  column-gap: 24px;\n  row-gap: 28px;\n  margin-top: 28px;\n}\n\n.checkout-analytics-card.MuiPaper-root.MuiCard-root {\n  height: 396px;\n  width: 40%;\n  align-self: stretch;\n  background: var(--white, #fff);\n  border-radius: 16px;\n  border: 1.2px solid var(--border-tertiary, rgba(1, 1, 2, 0.12));\n  box-shadow: none;\n  margin-left: 36px;\n}\n\n.funnel-text.MuiTypography-root {\n  font-family: \"Poppins\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.5px;\n}\n\n.info-icon-style {\n  margin-right: 8px;\n  padding-top: 4px;\n}\n\n.split-info-card.MuiPaper-root.MuiCard-root {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border-radius: 8px;\n  background: var(--conditional-pop-over, #fff);\n  margin-top: 16px;\n  box-shadow: none;\n}\n\n.split-info-cardContent.MuiCardContent-root {\n  display: flex;\n  flex-direction: row;\n  padding: 10px 16px !important;\n}\n\n.payment-trends-lineChart {\n  border-radius: 20px;\n  border: 1.4px solid #ececec;\n  background: var(--white, #fff);\n  box-shadow: none;\n  height: 500px;\n}\n\n.recharts-legend-wrapper {\n  position: absolute !important;\n  width: auto !important;\n  height: auto !important;\n  top: 90px !important;\n  right: 0 !important;\n  left: 315px !important;\n}\n\n.info-icon {\n  width: 10px;\n  height: 10px;\n  margin: auto 0;\n  margin-right: 4px;\n}\n\n.checkout-analytics-root {\n  width: 100%;\n  background: #fff;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
